import React from "react";
import { PDFExport } from "@progress/kendo-react-pdf";
import PropTypes from "prop-types";
import bg from "../../assets/images/HeaderDocument.jpg";
import sign_inno from "../../assets/images/sign_inno.png";
import "./base.css";

const HRM_022 = ({ pdfExportComponent, data, company, company2 }) => {
  return (
    <>
      <div id="document-box" className="documents">
        <PDFExport
          ref={pdfExportComponent}
          fileName={`การลงโปรแกรม Software ในผลิตภัณฑ์ของ Apple - ${data.personal_info_name}`}
          forcePageBreak=".page-break"
        >
          <div id="page1">
            <div>
              <img
                id="background"
                src={bg}
                alt="bg"
                style={{
                  width: "800px",
                  height: "auto",
                  position: "absolute",
                  top: "0%",
                  right: "0%",
                  zIndex: -5,
                  boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                }}
              />
            </div>
            <div
              id="content"
              style={{
                zIndex: 2,
              }}
            >
              <div
                id="formId"
                className="text-with-bold"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "122px",
                  right: "65px",
                  border: "1px",
                  borderStyle: "solid",
                  padding: "8px",
                  paddingBottom: "0px",
                  paddingTop: "5px",
                  width: "70px",
                  fontSize: "18.6px",
                  letterSpacing: 0.14,
                }}
              >
                <b className="docs-font">HRM-022</b>
              </div>
              <div
                id="formId"
                className="text-with-bold docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "131px",
                  right: "47px",
                  fontSize: "18.6px",
                  width: "710px",
                  letterSpacing: 0.14,
                  textAlign: "left",
                }}
              >
                เลขที่ COM 062009-1
              </div>

              <div
                id="date"
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "161px",
                  right: "47px",
                  fontSize: "18.6px",
                  width: "245px",
                  letterSpacing: 0.14,
                  textAlign: "justify",
                  // backgroundColor: "red"
                }}
              >
                วันที่…......…เดือน.......................พ.ศ.
                ..................
              </div>

              <div
                id="set-tab-text"
                className="text-with-bold docs-font-bold"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "228.8px",
                  right: "47px",
                  fontSize: "18.6px",
                  // fontFamily: "angsaLight",
                  width: "650px",
                  letterSpaing: 0.14,
                  textAlign: "justify",
                }}
              >
                พนักงานทุกท่าน/ทุกหน้าร้าน
              </div>
              <div
                id="paragraph1"
                className="text-with-bold docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "204px",
                  right: "47px",
                  fontSize: "18.6px",
                  // fontFamily: "angsaLight",
                  width: "710px",
                  letterSpacing: 0.14,
                  textAlign: "justify",
                  lineHeight: "24.8px",
                }}
              >
                เรื่อง&emsp;&emsp;การลงโปรแกรม Software ในผลิตภัณฑ์ของ Apple
                <br />
                เรียน
                <br />
                <br />
                &nbsp;&emsp;&emsp;&emsp;เนื่องจากการลงโปรแกรม Software
                ในผลิตภัณฑ์สินค้ายี่ห้อ Apple
                โดยไม่ได้รับอนุญาตจากเจ้าของลิขสิทธิ์ &nbsp;Software&nbsp;
                นั้นๆทั้งนี้รวมไปถึงโปรแกรมอื่นๆของ Microsoft, &nbsp;Adobe
                และของบริษัทอื่นๆถือเป็นการกระทำผิดข้อตกลงที่บริษัท คอมเซเว่น
                จำกัด &nbsp;(มหาชน)&nbsp; ได้ทำ ไว้กับบริษัท
                &nbsp;แอปเปิ้ล&nbsp; เซาท์ เอเชีย (ประเทศไทย) จำกัด
                &nbsp;(Apple-Thailand)&nbsp; ซึ่งถือว่าการลงโปรแกรม
                &nbsp;Software&nbsp; นั้นๆ เป็นการกระทำที่ผิด กฏหมาย
                เป็นการละเมิดลิขสิทธิ์ของเจ้าของ Software นั้นๆ
                <br />
                &nbsp;&emsp;&emsp;&emsp;ดังนั้น บริษัทฯ
                จึงขอประกาศให้พนักงานทุกท่านทราบ ดังต่อไปนี้
                <br />
                &nbsp;&nbsp;&emsp;&emsp;&emsp;&emsp;1.บริษัท ฯ
                ไม่อนุญาตให้พนักงานของร้าน &nbsp;&nbsp;Studio 7&nbsp;&nbsp;
                และพนักงานหน้าร้านอื่นๆรวมถึงสำนักงานของบริษัท ฯ ที่มีการ
                จำหน่ายผลิตภัณฑ์ของ Apple ที่มี Software ของ Apple, Microsoft,
                Adobe และของบริษัทอื่น ๆ (กฏหมายลิขสิทธิ์) ไว้เพื่อครอบครอง
                ทำซ้ำ แจกจ่าย และ/หรือ มีไว้ใน Harddisk / CD/DVD /
                และ/หรือสื่อบันทึกข้อมูลต่างๆภายในร้านไม่ว่ากรณีใดๆทั้งสิ้น
                <br />
                &nbsp;&nbsp;&nbsp;&emsp;&emsp;&emsp;&emsp;2.ห้ามมิให้มีการลงโปรแกรม
                Software ของ Apple, Microsoft, Adobe และของบริษัทอื่นๆ
                ที่ผิดกฎหมาย (กฏหมายลิขสิทธิ์) ในผลิตภัณฑ์ของ Apple
                เป็นอันขาดไม่ว่าด้วยกรณีใดๆทั้งสิ้น
                <br />
                &nbsp;&emsp;&emsp;&emsp;ทั้งนี้ Software ของ Apple หมายถึง
                Software ทุกชนิดที่ผลิตโดยบริษัท Apple (Apple Software) เช่น
                Aperture, Software ชุด Logic, Software ชุด Final Cut, iLife,
                iWork, OSX (Operating System), Software ชุด Quick Time, Software
                ชุด Garage Band Jam, Software ชุด Filemaker,XSan
                และโปรแกรมอื่นๆของทางบริษัท Apple
                <br />
                &nbsp;&emsp;&emsp;&emsp;Software ต่างๆ ที่ผลิตโดยบริษัท
                Microsoft เช่น Software ชุด Microsoft Office, Software ชุด
                Microsoft Windows และโปรแกรมอื่นของทางบริษัท Microsoft
                <br />
                &nbsp;&emsp;&emsp;&emsp;Software ต่างๆ ที่ผลิตโดยบริษัท Adobe
                เช่น Software ชุด Adobe Creative Suite, Software ชุด Adobe
                Macromedia และโปรแกรมอื่นของทางบริษัท Adobe
                <br />
                &nbsp;&emsp;&emsp;&emsp;Software ของบริษัทอื่นๆ
                ที่ผิดลิขสิทธิ์ทุกชนิด
                <br />
                &nbsp;&emsp;&emsp;&emsp;หากทางบริษัทฯ
                ตรวจพบว่ามีพนักงานท่านใดฝ่าฝืนประกาศฉบับนี้ ทางบริษัทฯ
                จะใช้บทลงโทษสูงสุดกับพนักงานท่านนั้น
                โดยให้พ้นสภาพการเป็นพนักงานของบริษัท ฯ ทันที
                โดยไม่มีข้อโต้แย้งใดๆ ทั้งสิ้น
                <br />
                &nbsp;&emsp;&emsp;&emsp;จึงเรียนมาเพื่อทราบและขอให้พนักงานทุกท่านปฏิบัติตามอย่างเคร่งครัด
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;รับทราบ
                <br />
                <br />
                &nbsp;&emsp;ลงชื่อ..............................................................
                <br />
                &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;พนักงาน
              </div>
              <img
                id="sign_inno"
                src={sign_inno}
                alt="sign_inno"
                style={{
                  height: "100px",
                  width: "178px",
                  position: "absolute",
                  top: "790px",
                  right: "275px",
                  zIndex: -5,
                }}
              />
              <div
                id="paragraph2"
                className="text-with-bold docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "873.6px",
                  right: "47px",
                  fontSize: "18.6px",
                  // fontFamily: "angsaLight",
                  width: "710px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  lineHeight: "24.8px",
                }}
              >
                นายคงศักดิ์ บรรณาสถิตย์กุล
                <br />
                บริษัท {company.name_th}
              </div>
            </div>
            <div id="var" className="var">
              {company2.head && (
                <img
                  src={company2.head}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "100px",
                    right: "10px",
                    top: "20px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
              {company2.foot && (
                <img
                  src={company2.foot}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "70px",
                    right: "10px",
                    top: "1060px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "158px",
                  right: "234px",
                  fontSize: "18.6px",
                  width: "33px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                {data.date_day}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "158px",
                  right: "136px",
                  fontSize: "18.6px",
                  width: "68px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                {data.date_month}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "158px",
                  right: "51px",
                  fontSize: "18.6px",
                  width: "60px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                {data.date_year}
              </div>
            </div>
          </div>
        </PDFExport>
      </div>
    </>
  );
};

HRM_022.propTypes = {
  data: PropTypes.object.isRequired,
  pdfExportComponent: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.object }),
  ]),
};

export default HRM_022;
